import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import CloudinaryImage from '../../../components/cloudinary-media/image'

const CardImage = ({selectedId, eGiftCardsJson, isGiftCert}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Box
            {...styles.leftBox.main}
            display={isGiftCert ? 'inline-flex' : undefined}
            justifyContent={isGiftCert ? 'center' : undefined}
        >
            {selectedId && (
                <CloudinaryImage
                    src={eGiftCardsJson[selectedId]}
                    alt={`Gift Card ${selectedId}`}
                    width={600}
                    aspectRatio="469:587"
                    imgSizes={{
                        base: '100vw',
                        md: '600px'
                    }}
                    sizes={[450, 650, 768, 1152, 1290, 1536, 1920]}
                    styles={{
                        aspectRatio: '469/587',
                        width: '100%',
                        maxWidth: isGiftCert ? '700px' : undefined,
                        padding: '0 9px',
                        height: 'auto',
                        borderRadius: {base: '0px', lg: '8px'},
                        objectFit: 'cover'
                    }}
                />
            )}
        </Box>
    )
}

CardImage.propTypes = {
    selectedId: PropTypes.string,
    eGiftCardsJson: PropTypes.object,
    isGiftCert: PropTypes.bool
}

export default CardImage
